import type { DependencyContainer } from 'tsyringe';

import { baseContainer } from '@/di/container';

export function useDependencyContainer(): DependencyContainer {
    return baseContainer;
}
